'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var styled = require('styled-components');
var iconButtons = require('./icon-buttons-442762e4.js');
var element = require('./element-2cae4d89.js');
var elementOutline = require('./element-outline-e92b8ea2.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject$3;
var actionButtonThemeStyle = iconButtons.createOwnUpButtonThemeStyle(element.ACTION_BUTTON_VARIANT);
var OwnUpActionButton = styled__default['default'](iconButtons.OwnUpButton)(_templateObject$3 || (_templateObject$3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), actionButtonThemeStyle, iconButtons.actionButtonStyle);

var _templateObject$2;
var lineButtonThemeStyle = iconButtons.createOwnUpButtonThemeStyle(element.LINE_BUTTON_VARIANT);
var OwnUpLineButton = styled__default['default'](iconButtons.OwnUpButton)(_templateObject$2 || (_templateObject$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), lineButtonThemeStyle, iconButtons.lineButtonStyle);

var _templateObject$1;
var iconSize = '1rem';
var backgroundRadius = '8px';

/**
 * Helper function to generate the various color schemes for
 *   the slim buttons, as well as base styling.
 */
var createStyledSlimButton = function createStyledSlimButton(variant) {
  return styled__default['default'](iconButtons.OwnUpButton)(_templateObject$1 || (_templateObject$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", "\n    ", "\n    ", "\n"])), iconButtons.baseButtonStyle, iconButtons.slimTextStyle, iconButtons.slimIconStyle, function (_ref) {
    var $idle = _ref.$idle,
      slimButtons = _ref.theme.buttonColors.slimButtons;
    var colorScheme = slimButtons[variant];
    return styled.css(["padding:0;border-radius:", ";color:", ";background:", ";&[aria-disabled='true']{color:", ";cursor:default;}", "{&:hover:not(&[aria-disabled='true']){background-color:", ";color:", ";}}&", "{background:", ";color:", ";", "}svg{width:", ";height:", ";path{fill:", ";}}"], backgroundRadius, $idle ? colorScheme.buttonIdleFontColor : colorScheme.buttonFontColor, $idle ? colorScheme.buttonIdleBackgroundColor : colorScheme.buttonBackgroundColorActive, $idle ? colorScheme.buttonIdleFontColor : colorScheme.buttonFontColor, iconButtons.stickyHoverMixin, colorScheme.buttonBackgroundColorHover, colorScheme.buttonFontColor, focusVisibleSelector.focusVisibleSelectorMixin, colorScheme.buttonBackgroundColorFocus, colorScheme.buttonFontColor, function (_ref2) {
      var innerSlimButtons = _ref2.theme.buttonColors.slimButtons;
      return elementOutline.createElementOutlineMixin({
        color: innerSlimButtons[variant].buttonFocusColor,
        width: iconButtons.buttonFocusWidth,
        inset: iconButtons.buttonFocusInset,
        radius: iconButtons.buttonFocusRadius
      });
    }, iconSize, iconSize, $idle ? colorScheme.buttonIdleIconColor : colorScheme.buttonIconColor);
  });
};

/**
 * Primary Own Up Slim Button. Wraps {@see OwnUpButton}
 *
 * @param {@see OwnUpButtonProps}
 */
var OwnUpSlimButtonPrimary = createStyledSlimButton(element.SLIM_BUTTON_PRIMARY_VARIANT);

/**
 * Secondary Own Up Slim Button. Wraps {@see OwnUpButton}
 *
 * @param {@see OwnUpButtonProps}
 */
var OwnUpSlimButtonSecondary = createStyledSlimButton(element.SLIM_BUTTON_SECONDARY_VARIANT);

var _templateObject;
var socialButtonThemeStyle = iconButtons.createOwnUpButtonThemeStyle(element.SOCIAL_BUTTON_VARIANT);
var OwnUpSocialButton = styled__default['default'](iconButtons.OwnUpButton)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), socialButtonThemeStyle, iconButtons.socialButtonStyle);

exports.OwnUpActionButton = OwnUpActionButton;
exports.OwnUpLineButton = OwnUpLineButton;
exports.OwnUpSlimButtonPrimary = OwnUpSlimButtonPrimary;
exports.OwnUpSlimButtonSecondary = OwnUpSlimButtonSecondary;
exports.OwnUpSocialButton = OwnUpSocialButton;
exports.createStyledSlimButton = createStyledSlimButton;
//# sourceMappingURL=social-button-8479390a.js.map
